export default "__VITE_ASSET__DQUGj9yw__"